module.exports = __webpack_public_path__ + "static/media/about-catalog.615f2aa2.png";